import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 2a6.5 6.5 0 100 13A6.5 6.5 0 008 2zm2.28 6.92l-3 2a.5.5 0 01-.63-.07.5.5 0 01-.15-.35v-4a.5.5 0 01.78-.42l3 2a.5.5 0 010 .84z" fill="#fff" /></svg>);